import React, { useState, useEffect } from 'react';
import { Card, Form, Button, Alert } from 'react-bootstrap';

/**
 * Simple Math Captcha Component
 * Prevents automated submissions
 * Expected value is stored server-side only for security
 */
const SimpleCaptcha = ({ onSuccess, onCancel }) => {
  const [question, setQuestion] = useState('');
  const [answer, setAnswer] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    generateCaptcha();
  }, []);

  const generateCaptcha = async () => {
    try {
      const response = await fetch('/api/tools/article/captcha/generate', {
        credentials: 'include'
      });
      const data = await response.json();
      setQuestion(data.question);
      // Note: expected value is NOT returned from server for security
      setLoading(false);
    } catch (err) {
      setError('Failed to load captcha');
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // Server-side validation only - don't validate on client
    try {
      const response = await fetch('/api/tools/article/captcha/verify', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ answer })
      });
      const data = await response.json();
      if (data.verified) {
        onSuccess();
      } else {
        setError('Incorrect answer. Please try again.');
        setAnswer('');
        generateCaptcha();
      }
    } catch (err) {
      setError('Verification failed');
    }
  };

  return (
    <Card style={{ maxWidth: '400px', margin: '0 auto' }}>
      <Card.Body>
        <Card.Title className="mb-3">Quick Verification</Card.Title>
        <p className="text-muted mb-3">Please answer this simple question to continue:</p>

        {loading ? (
          <p>Loading...</p>
        ) : (
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label style={{ fontSize: '1.25rem', fontWeight: '500' }}>
                {question}
              </Form.Label>
              <Form.Control
                type="number"
                value={answer}
                onChange={(e) => setAnswer(e.target.value)}
                placeholder="Enter your answer"
                autoFocus
              />
            </Form.Group>

            {error && <Alert variant="danger" className="mb-3">{error}</Alert>}

            <div className="d-flex gap-2">
              <Button type="submit" variant="primary" disabled={!answer}>
                Verify
              </Button>
              <Button variant="outline-secondary" onClick={onCancel}>
                Cancel
              </Button>
            </div>
          </Form>
        )}
      </Card.Body>
    </Card>
  );
};

export default SimpleCaptcha;
